// Adds a show/hide button to the password fields on the allauth pages
// (login, signup, password change/reset). Done here rather than in a
// template because allauth renders those fields via {{ form.as_p }}
// (templates/allauth/elements/fields.html).

const PASSWORD_INPUTS = document.querySelectorAll(
    '.allauth-form input[type="password"]'
)

const addToggle = (input) => {
    // `block` keeps the input on its own line under the label, as before
    const wrapper = document.createElement('span')
    wrapper.className = 'relative block'
    input.replaceWith(wrapper)
    wrapper.append(input)
    // Room for the button, so typed text doesn't run underneath it
    input.classList.add('pr-12')

    const button = document.createElement('button')
    button.type = 'button'
    button.className =
        'password-toggle text-text/70 hover:text-text absolute inset-y-0 right-0 flex cursor-pointer items-center px-4'
    button.setAttribute('aria-label', 'Show password')
    button.setAttribute('aria-pressed', 'false')
    if (input.id) button.setAttribute('aria-controls', input.id)
    button.innerHTML = `
        <span class="password-toggle__show" aria-hidden="true"><i class="fa-solid fa-eye pointer-events-none"></i></span>
        <span class="password-toggle__hide hidden" aria-hidden="true"><i class="fa-solid fa-eye-slash pointer-events-none"></i></span>
    `
    wrapper.append(button)

    const setVisible = (visible) => {
        input.type = visible ? 'text' : 'password'
        button.setAttribute('aria-pressed', visible)
        button
            .querySelector('.password-toggle__show')
            .classList.toggle('hidden', visible)
        button
            .querySelector('.password-toggle__hide')
            .classList.toggle('hidden', !visible)
    }

    button.addEventListener('click', () =>
        setVisible(input.type === 'password')
    )

    // Hide again before submitting, so password managers still recognise
    // the field as a password when offering to save it.
    input.form?.addEventListener('submit', () => setVisible(false))
}

PASSWORD_INPUTS.forEach(addToggle)
